import { combineReducers } from 'redux';
import { rosterTimeline } from './rosterReducer';
import { rosterBuilderTimeline } from './rosterBuilderReducer';
import { templateTimeline } from './templateReducer';
import { templateMapper } from './templateMapperReducer';
import { optimiserStatus } from './optimiserStatus';
import { validationBlock } from './validationBlock';
import { solaceHealth } from './solaceHealth';
import { optimiserRunStatus } from './optimiserRunStatus';
import site from './site';
import api from './api.reducer';

const rootReducer = combineReducers({
  rosterTimeline,
  templateTimeline,
  templateMapper,
  rosterBuilderTimeline,
  optimiserStatus,
  validationBlock,
  solaceHealth,
  optimiserRunStatus,
  api,
  site
});

export default rootReducer;
